<template>
  <action-button
    elevation="0"
    rounded
    :color="color"
    @click="$emit('click')"
  >
    <span :class="textClass">{{ text }}</span>
    <v-chip :class="chipClass" class="ml-2 px-1" x-small>
      {{ count }}
    </v-chip>
  </action-button>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import { Review } from '@/models';
import { DuplicateFilterBy } from '@/enums';

const FILTER_BY_TO_PROPS = {
  [DuplicateFilterBy.AUTO_RESOLVED]: {
    text: 'Auto-Resolved',
    count: (review) => review?.duplicatesAutoResolvedCount || 0,
  },
  [DuplicateFilterBy.REVIEWED]: {
    text: 'Reviewed',
    count: (review) => review?.duplicatesManuallyResolvedCount || 0,
  },
  [DuplicateFilterBy.REVIEW_NEEDED]: {
    text: 'Review Needed',
    count: (review) => review?.potentialDuplicatesCount || 0,
  },
};

export default {
  name: 'DuplicatesFilter',
  components: { ActionButton },
  props: {
    filterBy: {
      type: String,
      required: true,
      validator: (filterBy) =>
        Object.keys(FILTER_BY_TO_PROPS).includes(filterBy),
    },
    review: {
      type: Review,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    text() {
      return this.styleProps.text;
    },
    count() {
      return this.styleProps.count(this.review);
    },
    styleProps() {
      return FILTER_BY_TO_PROPS[this.filterBy];
    },
    color() {
      return this.selected ? 'primary' : 'grey lighten-2';
    },
    textClass() {
      return this.selected ? 'white--text' : 'grey--text';
    },
    chipClass() {
      return this.selected
        ? 'white primary--text'
        : 'grey lighten-1 grey--text text--darken-2';
    },
  },
};
</script>
